(function ($) {
  /**
   * Loyalty Marketing Formatter
   */
  Drupal.behaviors.ELB_loyalty_mrkt_landing = {
    attach: function (context, settings) {
      $(document.body).addClass('loyalty-marketing-page');
      var hasLoyalty = site.userInfoCookie.getValue('is_loyalty_member') - 0;
      var signedIn = site.userInfoCookie.getValue('signed_in') - 0;
      var $landing = $('.loyalty_mrkt_ldng');

      if (hasLoyalty && signedIn) {
        $landing.addClass('is_loyalty_member');
      } else if (signedIn) {
        $landing.addClass('not_loyalty_member');
      }
      // make sure buttons are hooked up
      if (site.loyalty) {
        site.loyalty.enrollmentBtn($landing);
      }

      var flexslider = $('.loyalty_marketing_points_slider');

      flexslider.flexslider({
        animation: 'slide',
        animationLoop: true,
        minItems: 1,
        maxItems: 1
      });
      flexslider.flexslider('resize');
      $(window).on('resize', function () {
        flexslider.flexslider('resize');
      });
    }
  };
})(jQuery);
